<template>
    <div class="ui-select-facebook-form">
        <ui-overlay-load v-if="load" />

        <div v-if="optionsComputed.length > 0" class="items-wrapper">
            <div class="items-scroller">
                <div class="items">
                    <template v-for="option of optionsComputed">
                        <div v-if="option.show_form"
                            :key="option.id"
                            :class="{ 'current': option == selected }"
                            class="item">
                            <ui-facebook-form-card :data="option" @selected-form="selectedFormHandler" />
                        </div>
                    </template>
                </div>
            </div>
        </div>

        <div v-if="inactiveFormsComputed.length < 1 && showFormWithoutIntegration || hasForm == 0" class="ui-no-content">
            <div class="title">Nenhum formulário do facebook foi encontrado.</div>
        </div>
    </div>
</template>

<script>
    import uiFacebookFormCard from "../facebook-form-card"
    import { uiOverlayLoad } from '@/components/ui'

    export default {
        components: {
            uiFacebookFormCard,
            uiOverlayLoad,
        },

        props: {
            value: {
                type: Array,
                required: false,
                default () {
                    return []
                }
            },
            showFormWithoutIntegration: {
                type: Boolean,
                required: true,
                default () {
                    return false
                }
            },
            default: {
                type: Number,
                required: false,
            },

            load: {
                type: Boolean,
                required: false,
            },
        },

        data() {
            return {
                selected: null,
                hasForm: 0,
            }
        },

        created: async function () {
            this.$root.$on('has-form', payload => {
                this.hasForm = payload
            })

            await this.$nextTick(() => {
                if (this.default && this.optionsComputed) {
                    this.selected = this.optionsComputed.find(option => option.id === this.default)
                    this.$emit("input", this.selected)
                }
            })
        },

        beforeDestroy() {
            this.$root.$off('has-form')
        },

        computed: {
            optionsComputed() {
                return Object.values(this.value).map(item => {
                    if (this.showFormWithoutIntegration) {
                        item.show_form = item.status_gs === 'inactive'

                    } else {
                        item.show_form = true
                    }

                    return item
                })
            },

            inactiveFormsComputed() {
                return Object.values(this.value).filter(item => {
                    return item.status_gs !== 'active'
                })
            },

            selectedComputed: {
                get() {
                    return this.default ? this.optionsComputed[this.default] : this.selected
                },
                set(value) {
                    if (value) {
                        this.selected = value
                        this.$emit('input', value)
                    }
                }
            },
        },

        methods: {
            select(option) {
                if (this.selectedComputed !== option) this.selectedComputed = option
            },
            /**
             * Evento disparado quando clica no botão da página
             */
            selectedFormHandler(event) {
                this.$emit('selected-form', event)
            }
        },

        watch: {
            value(newValue, oldValue) {
                if (newValue !== oldValue) {
                    this.selected = null
                    this.selectedComputed = null
                }
            }
        }
    }
</script>

<style lang="stylus" scoped>
    @import './styles.styl'
</style>